import { buttonVariants } from '@/components/shadcn/button'
import { cn } from '@/lib/utils'
import { Link } from 'react-router'
import { getProjectQuickLinkPath, getProjectQuickLinks } from './projectNavigation'

export function ProjectQuickLinks({
  projectId,
  showDmpChat,
  className,
}: {
  projectId: number
  showDmpChat: boolean
  className?: string
}) {
  const links = getProjectQuickLinks(showDmpChat)

  if (links.length === 0) {
    return null
  }

  return (
    <div className={cn('flex flex-col gap-5 pt-10', className)}>
      <h5 className="text-base font-bold text-foreground">Quick links</h5>
      <div className="flex flex-wrap gap-6">
        {links.map((link) => (
          <Link
            key={link.path}
            to={getProjectQuickLinkPath(projectId, link.path)}
            className={cn(buttonVariants({ variant: 'outline', size: 'sm' }), 'gap-1.5 px-0')}
          >
            <link.Icon className="size-4 shrink-0" />
            {link.title}
          </Link>
        ))}
      </div>
    </div>
  )
}
